import { NsList } from 'components/common/ns-list/NsList';
import { NsAlert } from 'components/common/ns-alert/NsAlert';

export const testId = 'agentScriptingIntroTestId';

type Props = {
  shouldShow?: boolean;
};
export const AgentScriptingIntro = ({ shouldShow }: Props) => {
  if (!shouldShow) {
    return null;
  }

  return (
    <NsAlert state="info" heading="Read the following" testId={testId}>
      <div>
        Does anyone living in the property have any vulnerabilities that we need
        to be aware of?
        <br />
        <br />
        This includes:
        <br />
        <br />
      </div>
      <NsList>
        {[
          `Children under the age of 6 or adults over the age of 65`,
          `Health issues we need to be aware of`,
          `Reliance on mains-powered medical equipment or keep medicine in the fridge`
        ]}
      </NsList>
    </NsAlert>
  );
};
